module.exports = __webpack_public_path__ + "img/s5_stepimg02@2x.eaf41e89.png";